module.exports = __webpack_public_path__ + "assets/images/confirm-email-mobile@2x.bcf90ea5f5f31d333fac4b065c08fe8c.webp";